history.scrollRestoration = "manual"
$(document).ready(function(){
  'use strict';
	// to cancel order ahead Reservation
  let userid  = $('#userId').val();
  const urlParams = new URLSearchParams(window.location.search);
  const myParam = urlParams.get('ref');
  let getPath = window.location.pathname;
    if(myParam && !userid){
      console.log("redirecting from restaurant-page");
      if (window.location.protocol=='https:') {
        window.location = 'https://' + window.location.hostname+'/users/login?next='+getPath;
            } else {
        window.location = 'http://' + window.location.hostname+'/users/login?next='+getPath;
          }
    }





  $('.notifySelect').select2({
    placeholder: "Select",
    allowClear: true
  });

  $('body').on('click', '.salespeople-accordion', function(){
    $(this).removeClass('salespeople-accordion');
    listSalespeople();
  })

  function listSalespeople() {
    var VENUEID = $('#venueId').val();
    if(VENUEID) {
      $.ajax({
        url: `/restaurantadmin/listsalesperson/${VENUEID}`,
        method: 'GET',
        contentType: 'application/json; charset=utf-8',
        success: function (salespeople) {
          if ($.fn.DataTable.isDataTable("#restaurantSalesTable")) {
            $("#restaurantSalesTable").dataTable().fnDestroy();
          }

          $("#restaurantSalesTable tbody").html("");
          var table = $('#restaurantSalesTable').DataTable({
            ordering: true,
            retrieve: true,
            responsive: true,
            data: salespeople,
            columns: [
              {
                data: 'fullName',
              },
              {
                data: 'email',
              },
              {
                data: 'status',
              },
              {
                data: 'invitedAt',
              }
            ],
          });

        },
        error: function (err) { },
      });
    }
  }

  $('#refresh_list_seles, .accordion-salespeople').click(function(){
    listSalespeople();
  })

  $('#sales_email').focus(function (event) {
    const isEmail = event.target.value;
    $(this).parent().removeClass('has-error');
    $(this).parent().find('span.help-block').html('');
    $('#submit_salespeople').removeAttr("disabled")
  })
  $('#sales_email').blur(function (event) {
    const isEmail = event.target.value;
    if (validateEmail(isEmail)) {
      $('#submit_salespeople').removeAttr("disabled");
    } else {
      $('#submit_salespeople').attr("disabled", true);
      $(this).parent().addClass('has-error');
      $(this).parent().find('span.help-block').html('Email is not valid.');
    }
  })

  $('#submit_salespeople').click(function(){
    const email_salespeople = $.trim($('#sales_email').val());
    if (validateEmail(email_salespeople)) {
      $.ajax({
        url: '/users/profile/restaurantAddSales',
        type: 'POST',
        contentType: 'application/json; charset=utf-8',
        data: JSON.stringify({ salespersonEmail: email_salespeople}),
        success: function (data) {
          if(data.code == 1) {
            Swal.fire('Oops', data.message, 'error');
          } else if (data.code == 2) {
            Swal.fire('No Change !', data.message, 'warning');
          } else {
            var dataSplit = data.split("|");
            if (dataSplit[0] < 0) {
              Swal.fire('Oops', dataSplit[1], 'error');
            }
            else if (dataSplit[0] == 0) {
              Swal.fire('No Change !', '', 'warning');
            }
            else {
              $('#sales_email').val('');
              Swal.fire('', dataSplit[1], 'success');
            }
          }
        },
        complete: listSalespeople,
        error: function (err) {
          Swal.fire('Oops', "We couldn't connect to the server!", 'error');
        },
      });
    }
  })
  $('body').on('click', '.btnDelSalespeople', function () {
    const slspersName = $(this).data('name');
    const slspersEmail = $(this).data('email');
    const slspersProfileId = $(this).data('id');

    Swal.fire({
      title: 'Are you sure to delete ' + slspersName + ' as a salesperson ? ',
      text: slspersName + ' (' + slspersEmail + ')',
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: 'Yes, I am sure !',
      confirmButtonColor: '#3cb371',
      cancelButtonText: 'No, cancel it !',
      cancelButtonColor: '#d9534f',
    }).then((result) => {
          if (result.isConfirmed) {
       

      $.ajax({
        url: '/users/profile/restaurantDeleteSales',
        type: 'POST',
        contentType: 'application/json; charset=utf-8',
        data: JSON.stringify({ slspersProfileId: slspersProfileId }),
        success: function (data) {

          var dataSplit = data.split('|');
          if (dataSplit[0] == 1) {
            Swal.fire("Deleted!", dataSplit[1], "success");
            listSalespeople();
          }
          else if (dataSplit[0] == 2) {
            //delete self
            location.reload();
          }
          else {
            Swal.fire("Oops", dataSplit[1], "error");
          }
        },
        error: function (err) {
          Swal.fire("Oops", "We couldn't connect to the server!", "error");
        },
      });
    }
    });
  });

  function validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  //Link map
  $('#link-map, #order-take-me-there').click(function () {
        console.log("redirecting from restaurant-page...order takemmethere");

    const address = $(this).data('address');
    const LINK_MAP_WEB = `https://www.google.com/maps/dir/Current+Location/${address}`;
    const LINK_MAP_IOSAPP = "plateratewebtonative:openMapView?daddr=" + encodeURIComponent(address);
    const LINK_MAP_ANDROIDAPP = 'maps://maps.google.com/maps/dir/Current+Location/${address}'
    if (check_iOS_App()) {
      window.location = LINK_MAP_IOSAPP;
    } else if (check_Android_app()) {
      window.open(LINK_MAP_ANDROIDAPP);
    } else {
      window.open(LINK_MAP_WEB, '_blank');
    }
  })

  function check_iOS_App() {
    return (/(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(navigator.userAgent)) ? true : false;
  }
  function check_Android_app () {
    return (window.navigator.userAgent == 'PlateRateForAndroid');
  }

});

$(function() {
  /**
  * Agreements with platerate
  */
  if($('#history-contract').length) {

    $('#btn-refresh-agreement').on('click', function() {
      reloadAgreementsHistory();
    })
    
    $('body').on('click', '.contract-accordion', function(){
      $(this).removeClass('contract-accordion');
      reloadAgreementsHistory();
    })

    $('body').on('click', '.contract-accordion', function(){
      $(this).removeClass('contract-accordion');
      reloadAgreementsHistory();
    })

    function reloadAgreementsHistory () {
      var venueId = $('#venue-id').text().trim();
      $('#history-contract tbody').html('<tr><td colspan="3">Loading. . .</td></tr>');
      $.ajax({
        url: '/merchantAgreementHistory',
        method: 'POST',
        contentType: "application/json; charset=utf-8",
        data: JSON.stringify({ venueId: venueId }),
        dataType: 'json',
        error: function (err) {
          $('#history-contract tbody').html('<tr>Agreement not found!</tr>');
        }
      }).then((data)  => {
        reloadAgreements(data, venueId);
      });
    }

    function reloadAgreements(agreement, venueId) {
      if ($.fn.DataTable.isDataTable("#history-contract")) {
        $("#history-contract").dataTable().fnDestroy();
      }
      if(agreement && agreement.length) {
        $("#history-contract tbody").html("");
        $('#history-contract').DataTable({
          ordering: true,
          retrieve: true,
          responsive: true,
          data: agreement,
          order: [[ 1, 'desc' ]],
          columns: [
            {
              data: 'nameAgreement',
            },
            {
              data: 'createdDate',
            },
            {
              data: null,
              orderable: false,
            },
          ],
          createdRow: function (row, data, index) {
            let urlview ='javascript:void(0)'
            if (data._id && data._id.match(/^[0-9a-fA-F]{24}$/)) urlview = `/restaurant/agreement-history/${venueId}/${data._id}`;
            let linka = `<a href="${urlview}" target="_blank" class="btn btn-green" style="font-size: 11px">View</a>`
            $('td', row).eq(-1).html(linka).css('text-align', 'center');
            const myDate = new Date(data.createdDate);
            const date = moment(myDate).format('MM-DD-YYYY HH:MM:SS');
            $('td', row).eq(-2).html(`<small class="green">at </small><span>${date}</span>`).css('text-align', 'center');
          }
        })
      } else {
        let constractHTML = '<tr><td colspan="3">Agreement not found!</td></tr>';
        $('#history-contract tbody').html(constractHTML);
      }
    }
  }
})


// $(document).on('click','.order-item-rating-accordion',function(){
	// if(window.navigator && window.navigator.userAgent){
	// $(".pinterest-share-button-web").children("a").trigger('click');
    // var userAgent = window.navigator.userAgent;
    // if(userAgent == "PlateRateForIOS" || userAgent == 'PlateRateForAndroid'){
        // $(".insta-share-button").show();
        // $(".pinterest-share-button-web").addClass('hide');
        // $(".pinterest-share-button-mobile").removeClass('hide');
    // } else {
        // $(".pinterest-share-button-web").removeClass('hide');
        // $(".pinterest-share-button-mobile").addClass('hide');
    // }
  // }
// })
$(document).on('click','.order-item-rating-accordion',function(){
	if(window.navigator && window.navigator.userAgent){
    var userAgent = window.navigator.userAgent;
    if(userAgent == "PlateRateForIOS" || userAgent == 'PlateRateForAndroid'){
        $(".insta-share-button").show();
        $(".pinterest-share-button-web").hide();
        $(".pinterest-share-button-mobile").show();
    } else {
        $(".pinterest-share-button-web").show();
        $(".pinterest-share-button-mobile").hide();
    }
  }
})
